enum SpecOutStatus {
	Draft = 10,
	Sent = 90,
	Deleted = 100,
}

export default SpecOutStatus;
